import { Component, OnInit, ViewContainerRef, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { EmployeeDiscount, EdValidators } from '../../../models/employee-discount';
import {ApiService} from '../../../services/api.service';
import { ModalDialogService } from 'ngx-modal-dialog';
import {AlgCfModalComponent} from '../../dialogs/alg-cf-modal/alg-cf-modal.component';
import { CustomValidators } from 'ng2-validation';
import { UtilsService } from '../../../services/utils.service';
import { AlgScontoService } from '../../../services/alg-sconto.service';

const privacyData = require('../../../data/privacy.json');

@Component({
  selector: 'alg-sconto-form',
  templateUrl: './alg-sconto-form.component.html',
  styleUrls: ['./alg-sconto-form.component.scss']
})
export class AlgScontoFormComponent implements OnInit {
  @Input() reverse: boolean;

  public userInfoForm: FormGroup;
  public employeeDiscount: EmployeeDiscount = {} as EmployeeDiscount;
  public informativeNoteUrl$: Observable<string>;
  public isCfVisible = false;
  public prefixes = [{label:'+39', value:'+39'}, {label:'+33', value: '+33'}];
  public privacyOptions = [{
    label: 'Do il consenso',
    value: 'agree'
  }, {
    label: 'Nego il consenso',
    value: 'disagree'
  }];
  public coops: any[] = [];
  public privacyItems: any;
  private privacyFieldsMap = {
    commercialiALG: 'privacyComCom',
    profilazioneALG: 'privacyProf',
    'qualità': 'privacyQualServ',
    commercialiTerzi: 'privacyComTer',
    profilazioneTerzi: 'privacyProfTer'
  };
  public subscriberOptions = [{
    label: 'Intestate al dipendente sottoscrittore del presente modulo',
    value: 'dipendente'
  }, {
    label: 'Intestate a Coniuge/Convivente',
    value: 'coniuge'
  }];
  public dipSubscriber = true;
  public cfError = false;
  public customer_cf_error_message = 'CF_FORMAL_ERROR';
  public lb_error_message = 'Esiste già una domanda registrata in data $date$ alle ore $time$ inserita da $nome$ $cognome$ vuoi proseguire?';
  public sameCfMessage = false;


  constructor(
    private api: ApiService,
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef,
    private sconto: AlgScontoService
  ) { }

  // Removed 'COOP ALLEANZA 3.0', 'UNICOOP TIRRENO e CONTROLLATE',
  ngOnInit() {
    this.coops = [
      'AZ GROUP', 'COOP RENO', 'TATO’ GROUP'
    ].map(n => ({label: n, value: `${n}`}));

    this.employeeDiscount.subscriber = 'dipendente';

    this.userInfoForm = new FormGroup({
      firstname: new FormControl(this.employeeDiscount.employee_firstname, {
        validators: [Validators.required]
      }),
      lastname: new FormControl(this.employeeDiscount.employee_lastname, {
        validators: [Validators.required]
      }),
      cf: new FormControl(this.employeeDiscount.employee_cf, {
        validators: [
          Validators.required,
          EdValidators.cf,
        ]
      }),
      email: new FormControl(this.employeeDiscount.employee_email, {
        validators: [
          Validators.required,
          CustomValidators.email
        ]
      }),
      coop: new FormControl(this.employeeDiscount.employee_coop, {
        validators: [Validators.required],
      }),
      subscriber: new FormControl(this.employeeDiscount.subscriber, {
        validators: [Validators.required],
      }),
      customer_firstname: new FormControl(this.employeeDiscount.customer_firstname, {

      }),
      customer_lastname: new FormControl(this.employeeDiscount.customer_lastname, {

      }),
      customer_cf: new FormControl(this.employeeDiscount.customer_cf, {

      }),
    });

    this.userInfoForm.valueChanges.subscribe(data => {
      if(data.firstname && data.lastname){
        this.isCfVisible = true;
      } else {
        this.isCfVisible = false;
      }
    });

    this.privacyItems = Object.keys(privacyData)
    .filter((key) =>
      ['accendi'].indexOf(key) === -1
      // ['commercialiTerzi', 'profilazioneTerzi', 'accendi'].indexOf(key) === -1
    ) // HACK: removes it to re-eanble last two consents (leave only 'accendi')
    .slice(2).map(e => {
      privacyData[e]['id'] = this.privacyFieldsMap[e];
      privacyData[e]['modalFlag'] = e;
      return privacyData[e];
    });
  }
  // end oninit

  public saveDiscount() {
    if (this.userInfoForm.status === 'VALID') {
      this.api.saveDiscount(this.employeeDiscount).subscribe(result => (this.checkResult(result)));
    }
  }

  private checkResult(res) {
    if(res.success === true) {
      this.sconto.sendResult(res);
    }
    else if(res.success === false) {
      this.cfError = true;
      if(res.res){
        let today = new Date(Date.parse(res.res[res.res.length-1].createdAt));
        let dd = today.getDate().toString();
        let mm = (today.getMonth()+1).toString();
        let yyyy = today.getFullYear();
        let hh = (today.getHours()).toString(); //remember time zone
        let mi = today.getMinutes().toString();
        if(parseInt(dd)<10) {
            dd = '0'+dd
        }
        if(parseInt(mm)<10) {
            mm = '0'+mm
        }
        if(parseInt(hh)<10) {
          hh = '0'+hh
        }
        if(parseInt(mi)<10) {
            mi = '0'+mi
        }
        let day = dd + '/' + mm + '/' + yyyy;
        let time = hh+':'+mi;
        this.lb_error_message = this.lb_error_message.replace('$date$',day.toString()).replace('$time$',time.toString()).replace('$nome$',res.res[0].employee_firstname).replace('$cognome$',res.res[0].employee_lastname)
      }
    }
  }


  public openCFModal(){
    this.utils.disableOverflow();
    this.modalDialogService.openDialog(this.viewContainer, {
      title: `Compila qua il tuo codice fiscale`,
      childComponent: AlgCfModalComponent,
      settings: {
        closeButtonClass: 'close theme-icon-close',
        headerTitleClass: ' modal-title modal-title-underline'
      },
      data: this.employeeDiscount
    });
  }

  changeSubscriber(event) {
    if (event.target.value === 'coniuge') {
      this.dipSubscriber = false;
      this.userInfoForm.get('customer_firstname').setValidators([Validators.required]);
      this.userInfoForm.get('customer_lastname').setValidators([Validators.required]);
      this.userInfoForm.get('customer_cf').setValidators([Validators.required, EdValidators.cf, EdValidators.sameCf]);
    }else{
      this.dipSubscriber = true;
      this.userInfoForm.get('customer_firstname').clearValidators();
      this.userInfoForm.get('customer_lastname').clearValidators();
      this.userInfoForm.get('customer_cf').clearValidators();
    }
    this.userInfoForm.get('customer_firstname').updateValueAndValidity();
    this.userInfoForm.get('customer_lastname').updateValueAndValidity();
    this.userInfoForm.get('customer_cf').updateValueAndValidity();
  }

  cancelRequest(){
    this.cfError = false;
  }

  proceedRequest(){
    this.api.forceSaveDiscount(this.employeeDiscount).subscribe(result => (this.checkResult(result)));
    this.cfError = false;
  }

  checkCfError(){
    if(this.employeeDiscount.customer_cf === this.employeeDiscount.employee_cf){
      this.sameCfMessage = true;
    }else{
      this.sameCfMessage = false;
    }
    // if(this.userInfoForm.get('customer_cf').hasError('customer_cf')){
    //   this.customer_cf_error_message = 'CF_SAME';
    // }else{
    //   this.customer_cf_error_message = 'CF_FORMAL_ERROR';
    // }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-sconto-form/alg-sconto-form.component.ts